import React from 'react';
import { LuChevronDown } from 'react-icons/lu';
import { setLocalePreference } from '../utils/locale';
import '../styles/LanguageToggle.css';

export default function LanguageToggle({ locale, className = '' }) {
  return (
    <button type="button" className={`language-toggle ${className}`} onClick={() => setLocalePreference(locale === 'ja' ? 'en' : 'ja')}
      aria-label={locale === 'ja' ? '表示言語を英語に切り替える' : 'Switch language to Japanese'}>
      <span>{locale === 'ja' ? 'JA / EN' : 'EN / JA'}</span>
      <LuChevronDown aria-hidden="true" />
    </button>
  );
}
